import { _API, _HEADER, _AXIOS_HELPER } from '@/static';
import * as ENUM from "@/enum/lib";

export default {
    login: function (userEmail, userPassword, fcmToken) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/login';
            const conf = {
                headers: _HEADER()
            };
            const data = {
                userEmail,
                userPassword,
                userType: `manager`,
                fcmToken
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    if (res.data.isSuccess) {
                        localStorage.setItem('seqUser', res.data.user.seqUser);
                        localStorage.setItem('seqManager', res.data.user.seqManager);
                        localStorage.setItem('userEmail', res.data.user.userEmail);
                        localStorage.setItem('userName', res.data.user.userName);
                        localStorage.setItem('accessToken', res.data.token.accessToken);
                        localStorage.setItem('refreshToken', res.data.token.refreshToken);
                        resolve(res);
                    } else {
                        reject(res.data.failedCode);
                    }
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // validateUserId: function (userId) {
    //     return new Promise((resolve, reject) => {
    //         const url = _API + '/user/validUserId';     //API에서 알맞는 PATH를 지정해 줍니다.
    //         const conf = {
    //             headers: _HEADER()
    //         };
    //         const data = { userId };
    //         _AXIOS_HELPER(ENUM.HTTP_METHOD.POST,url, data, conf)
    //             .then( res => {
    //                 resolve( res );
    //             })
    //             .catch( err => {
    //                 reject( err );
    //             });
    //     })
    // },
    validateUserEmail: function (userEmail) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/validUserEmail';   //API에서 알맞는 PATH를 지정해 줍니다.
            const conf = {
                headers: _HEADER()
            };
            const data = {userEmail};
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    registerUser: function (inputData) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/signUp';   //API에서 알맞는 PATH를 지정해 줍니다.
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, inputData, conf, true)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        })
    },
    resendAuthEmail: function (inputData) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/resendAuthEmail';
            const conf = {
                headers: _HEADER()
            };
            const data = {
                userEmail: inputData
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    deleteAccount: function () {
        return new Promise((resolve, reject) => {
            const url = _API + '/manager/deleteManagerAccount';
            const conf = {
                headers: _HEADER()
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.PUT, url, {}, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    confirmUserPassword: function (password) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/confirmUserPassword';
            const conf = {
                headers: _HEADER()
            };
            const data = {password};
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    },
    // findUserIdViaEmail: function (userEmail) {
    //     return new Promise((resolve, reject) => {
    //         const url = _API + '/user/findUserIdViaEmail';
    //         const conf = {
    //             headers: _HEADER()
    //         };
    //         const data = { userEmail };
    //         _AXIOS_HELPER(ENUM.HTTP_METHOD.POST,url, data, conf)
    //             .then( res => {
    //                 resolve( res );
    //             })
    //             .catch( err => {
    //                 reject( err );
    //             });
    //     });
    // },
    sendResetPasswordViaEmail: function (inputData) {
        return new Promise((resolve, reject) => {
            const url = _API + '/user/resetManagerPw';
            const conf = {
                headers: _HEADER()
            };
            const data = {
                userEmail: inputData.userEmail
            };
            _AXIOS_HELPER(ENUM.HTTP_METHOD.POST, url, data, conf)
                .then(res => {
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
}